import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const referral: IMcAppType = {
  name: "referral",
  path: "/my/referral",
  description: "Refer a friend",
  navFlow: NavFlow.STANDARD,
  title: "Refer a friend",
  parent: Tab.MORE,

  conditions: {
    intent: "referral",
    customerType: CustomerType.kraken,
  },
};
